<tran-checkbox-tree-view-selection
    [control]="control()"
    [displayControl]="displayControl()"
    [items]="orgUnits()"
    [label]="label()"
    [itemId]="orgUnitItemId"
    [itemLabel]="orgUnitItemLabel"
    [itemCategory]="orgUnitCategory"
    [readonly]="readonly()"
    [submitted]="submitted()"
/>
